import { render, staticRenderFns } from "./QesAuthenticateMainPage.vue?vue&type=template&id=200abc92&"
import script from "./QesAuthenticateMainPage.vue?vue&type=script&lang=js&"
export * from "./QesAuthenticateMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports